import { render } from "./welcomeComponent.vue?vue&type=template&id=1b11261e"
import script from "./welcomeComponent.vue?vue&type=script&lang=js"
export * from "./welcomeComponent.vue?vue&type=script&lang=js"

import "./welcomeComponent.vue?vue&type=style&index=0&id=1b11261e&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/welcomeComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b11261e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b11261e', __exports__)) {
    api.reload('1b11261e', __exports__)
  }
  
  module.hot.accept("./welcomeComponent.vue?vue&type=template&id=1b11261e", () => {
    api.rerender('1b11261e', render)
  })

}


export default __exports__